import React, {useContext} from 'react';
import {blank} from '@/util';
import MainSiteLink from '@/components/MainSiteLink';
import {contactUs, privacyLink, disclaimerLink} from '@/contexts/support-link';
import {useTranslation} from 'react-i18next';
import {SystemConfigCtx} from '@/contexts';

const Footer = () => {
  const {t: tr} = useTranslation('common');
  const currentYear = new Date().getFullYear();
  const {siteCode, siteName = ''} = useContext(SystemConfigCtx);

  if (blank(siteCode)) {
    return null;
  }

  return (
    <footer>
      <div className='container clearfix'>
        <ul>
          <li>
            <MainSiteLink href={contactUs(siteCode)}>
              {tr('main_site_contact_us')}
            </MainSiteLink>
          </li>
          <li>
            <MainSiteLink href={privacyLink}>
              {tr('main_site_privacy')}
            </MainSiteLink>
          </li>
          <li>
            <MainSiteLink href={disclaimerLink}>
              {tr('main_site_disclaimer')}
            </MainSiteLink>
          </li>
        </ul>
        <small>
          @ {currentYear} {siteName.toUpperCase()}
        </small>
      </div>
    </footer>
  );
};

export default Footer;
